/* SUPER10 — ポイント還元の表示値を「表示通貨→USD」に補正する。
 *
 * なぜ必要か:
 *   ポイントは loyalty_engine.py が discountedTotalSet.shopMoney (= 基準通貨USD) を
 *   元に round(USD * rate% * 100) で付与する (100pt = $1)。
 *   一方 Liquid の variant.price / cart.total_price は「表示通貨」で返るため、
 *   EUR等でそのまま計算するとレートの分だけ pts がズレる。
 *   Shopify.currency.rate (= 表示通貨/基準通貨) で割り戻して USD に直してから計算する。
 *   USD圏では rate=1 なのでサーバ側の値と一致する（=何も壊れない）。
 *
 * 使い方 (Liquid側):
 *   <span data-s10-pts data-cents="{{ variant.price }}" data-pct="{{ eff_rate }}">
 *     Earn <strong data-s10-pts-val>...</strong> (<span data-s10-pts-usd>...</span>) ...
 *   </span>
 *   data-cents = 表示通貨の最小単位 / data-pct = 還元率(%)
 *   data-s10-pts-usd は任意（無ければ pts だけ更新）。
 */
(function () {
  function fxRate() {
    try {
      var c = window.Shopify && window.Shopify.currency;
      var r = c && parseFloat(c.rate);
      return r && isFinite(r) && r > 0 ? r : 1;
    } catch (e) {
      return 1;
    }
  }

  function render(el) {
    var cents = parseInt(el.getAttribute('data-cents'), 10);
    var pct = parseFloat(el.getAttribute('data-pct'));
    if (!isFinite(cents) || !isFinite(pct)) return;

    var usd = cents / 100 / fxRate();
    // 100pt = $1 なので pts = usd * (pct/100) * 100 = usd * pct
    var pts = Math.round(usd * pct);

    var ptsEl = el.querySelector('[data-s10-pts-val]');
    if (ptsEl) ptsEl.textContent = pts.toLocaleString('en-US') + ' pts';

    var usdEl = el.querySelector('[data-s10-pts-usd]');
    if (usdEl) usdEl.textContent = '$' + (pts / 100).toFixed(2);
  }

  function run(root) {
    (root || document).querySelectorAll('[data-s10-pts]').forEach(render);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); });
  } else {
    run();
  }

  // カートドロワー/セクションは再描画でサーバ側の値に戻るため、差し替わったら再計算する。
  var obs = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.hasAttribute && n.hasAttribute('data-s10-pts')) render(n);
        else if (n.querySelectorAll) run(n);
      }
    }
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
